import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import EvvReport from "./EVVReports/EVVReport";
import EvvInvoice from "./EVVReports/EVVInvoice";

export default function EVV_Reports(props) {
    const [activeKey, setActiveKey] = useState("evvReport");
    const availableReports = [
        props.user.permissions.EVVReport && { key: "evvReport", label: "EVV Report" },
        props.user.permissions.EVVInvoice && { key: "evvInvoice", label: "EVV Invoice" },
    ].filter(Boolean);

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        setActiveKey(props.activeSubKey)
    }, [props.activeSubKey]);

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ flexShrink: 0 }}>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 8,
                        marginLeft: 10
                    }}
                >
                    EVV Reports
                </Typography>
            </div>
            <div style={{ width: '100%', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                {availableReports.length > 1 && (
                    <Tabs
                        value={activeKey}
                        onChange={handleKeyChange}
                        variant="scrollable"
                        sx={{
                            flexShrink: 0,
                            borderBottom: 1,
                            borderColor: 'divider',
                            '& .Mui-selected': {
                                backgroundColor: '#f0f0f0',
                                fontWeight: 'bold',
                                width: 'inherit'
                            }
                        }}
                    >
                        {availableReports.map((report) => (
                            <Tab key={report.key} value={report.key} label={report.label} />
                        ))}
                    </Tabs>
                )}

                <div style={{ width: '100%', flex: 1, minHeight: 0, overflow: activeKey === "evvReport" ? 'hidden' : 'auto' }}>
                    {activeKey === "evvReport" && <EvvReport {...props} />}
                    {activeKey === "evvInvoice" && <EvvInvoice {...props} />}
                </div>
            </div>
        </div>
    )
};
